/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { getContents, addContent, deleteContent, uploadContent, getLocations, getPlaylists } from '../api';
import { supabase } from '../supabase';

export default function Contents() {
  const [contents, setContents] = useState([]);
  const [locations, setLocations] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [playlistItems, setPlaylistItems] = useState({});
  const [selectedLocation, setSelectedLocation] = useState('all');
  const [tab, setTab] = useState('image');
  const [form, setForm] = useState({ name: '', url: '', body: '', duration_sec: 10 });
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const load = async () => {
    const [cRes, lRes, pRes] = await Promise.all([getContents(), getLocations(), getPlaylists()]);
    setContents(cRes.data);
    setLocations(lRes.data);
    setPlaylists(pRes.data);
    const items = {};
    for (const pl of pRes.data) {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/playlists/${pl.id}/items`, { headers: { Authorization: `Bearer ${session?.access_token}` } });
        const data = await res.json();
        items[pl.id] = (data || []).map(i => i.content_id);
      } catch (e) {}
    }
    setPlaylistItems(items);
  };

  useEffect(() => { load(); }, []);

  const getLocationContentIds = (locId) => {
    const loc = locations.find(l => l.id === locId);
    if (!loc) return new Set();
    const ids = new Set();
    (loc.screens || []).forEach(scr => {
      if (scr.playlist_id && playlistItems[scr.playlist_id]) {
        playlistItems[scr.playlist_id].forEach(cid => ids.add(cid));
      }
    });
    return ids;
  };

  const filtered = selectedLocation === 'all' ? contents : contents.filter(c => getLocationContentIds(selectedLocation).has(c.id));

  const handleUpload = async () => {
    if (!file || !form.name) return;
    setUploading(true);
    const fd = new FormData();
    fd.append('file', file); fd.append('name', form.name); fd.append('type', tab); fd.append('duration_sec', form.duration_sec);
    await uploadContent(fd);
    setFile(null); setForm({ name: '', url: '', body: '', duration_sec: 10 }); setUploading(false); setShowForm(false); load();
  };

  const handleAddUrlOrData = async () => {
    if (!form.name) return;
    await addContent({ name: form.name, type: tab, url: form.url, body: form.body, duration_sec: form.duration_sec });
    setForm({ name: '', url: '', body: '', duration_sec: 10 }); setShowForm(false); load();
  };

  const typeLabel = { image: '🖼️ Image', video: '🎬 Video', pdf: '📄 PDF', url: '🌐 URL', data: '📋 Custom' };
  const typeMeta = {
    image: { color: '#2D6A4F', bg: '#E8F5EE' },
    video: { color: '#1565C0', bg: '#E3F2FD' },
    pdf:   { color: '#8B1E2D', bg: '#FDE8E8' },
    url:   { color: '#C45000', bg: '#FFF3E0' },
    data:  { color: '#6A1B9A', bg: '#F3E5F5' },
  };
  const acceptMap = { image: 'image/*', video: 'video/*', pdf: 'application/pdf' };
  const isFileBased = tab === 'image' || tab === 'video' || tab === 'pdf';

  return (
    <div style={{ background: '#F8F6F3', minHeight: '100%' }}>
      <div style={hdr}>
        <h1 style={pageTitle}>Content Library</h1>
        <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>+ Add</button>
      </div>

      <div style={{ padding: '16px' }}>
        {/* Add content form */}
        {showForm && (
          <div style={formCard}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: '#555' }}>New Content</div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
              {['image', 'video', 'pdf', 'url', 'data'].map(t => (
                <button key={t} onClick={() => setTab(t)}
                  style={{ padding: '6px 12px', borderRadius: 20, border: `1px solid ${tab === t ? '#8B1E2D' : '#E8E3DC'}`, cursor: 'pointer', fontSize: 12, fontWeight: tab === t ? 600 : 400, background: tab === t ? '#8B1E2D' : '#fff', color: tab === t ? '#fff' : '#555' }}>
                  {typeLabel[t]}
                </button>
              ))}
            </div>
            <input placeholder="Content name *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ ...inp, marginBottom: 10 }} />
            {isFileBased && (
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 14px', background: '#F5F3F0', border: '1px solid #E8E3DC', borderRadius: 8, cursor: 'pointer', fontSize: 13, marginBottom: 10 }}>
                📁 {file ? file.name : `Choose ${tab === 'pdf' ? 'PDF' : 'file'}`}
                <input type="file" accept={acceptMap[tab]} onChange={e => setFile(e.target.files[0])} style={{ display: 'none' }} />
              </label>
            )}
            {tab === 'url' && <input placeholder="https://..." value={form.url} onChange={e => setForm({ ...form, url: e.target.value })} style={{ ...inp, marginBottom: 10 }} />}
            {tab === 'data' && <textarea placeholder="Content text" value={form.body} onChange={e => setForm({ ...form, body: e.target.value })} style={{ ...inp, height: 80, resize: 'vertical', marginBottom: 10 }} />}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <span style={{ fontSize: 13, color: '#666' }}>Duration:</span>
              <input type="number" value={form.duration_sec} onChange={e => setForm({ ...form, duration_sec: e.target.value })} style={{ ...inp, width: 70 }} />
              <span style={{ fontSize: 13, color: '#666' }}>sec</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={isFileBased ? handleUpload : handleAddUrlOrData} disabled={uploading} style={btnPrimary}>
                {uploading ? 'Uploading...' : isFileBased ? '⬆️ Upload' : '+ Add'}
              </button>
              <button onClick={() => setShowForm(false)} style={btnGhost}>Cancel</button>
            </div>
          </div>
        )}

        {/* Location filter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
          <select value={selectedLocation} onChange={e => setSelectedLocation(e.target.value)} style={{ ...selectSt, flex: 1, minWidth: 0 }}>
            <option value="all">All locations ({contents.length})</option>
            {locations.map(loc => <option key={loc.id} value={loc.id}>{loc.name} ({getLocationContentIds(loc.id).size})</option>)}
          </select>
          {selectedLocation !== 'all' && <button onClick={() => setSelectedLocation('all')} style={btnGhost}>Clear</button>}
          <span style={{ fontSize: 12, color: '#aaa', whiteSpace: 'nowrap' }}>{filtered.length} item{filtered.length !== 1 ? 's' : ''}</span>
        </div>

        {/* Mobile: cards */}
        {isMobile ? (
          <div>
            {filtered.map((c) => {
              const meta = typeMeta[c.type] || { color: '#666', bg: '#eee' };
              return (
                <div key={c.id} style={{ background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, padding: '12px 14px', marginBottom: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1, minWidth: 0, marginRight: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ background: meta.bg, color: meta.color, padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                          {typeLabel[c.type] || c.type}
                        </span>
                        <span style={{ fontSize: 11, color: '#aaa' }}>{c.duration_sec}s</span>
                      </div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: '#1A1A1A', marginBottom: 4 }}>{c.name}</div>
                      <div style={{ fontSize: 11, color: '#bbb', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {c.url ? c.url.replace('https://', '').substring(0, 40) : c.body ? c.body.substring(0, 40) : '—'}
                      </div>
                    </div>
                    <button onClick={() => deleteContent(c.id).then(load)} style={btnDanger}>Delete</button>
                  </div>
                </div>
              );
            })}
            {filtered.length === 0 && (
              <div style={{ padding: 32, textAlign: 'center', color: '#aaa', fontSize: 14 }}>No content yet.</div>
            )}
          </div>
        ) : (
          /* Desktop: table */
          <div style={tableWrap}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #E8E3DC' }}>
                  <th style={th}>Type</th>
                  <th style={th}>Name</th>
                  <th style={{ ...th, textAlign: 'center' }}>Duration</th>
                  <th style={th}>Source</th>
                  <th style={th}></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((c, i) => {
                  const meta = typeMeta[c.type] || { color: '#666', bg: '#eee' };
                  return (
                    <tr key={c.id} style={{ borderBottom: '1px solid #F0EBE4', background: i % 2 === 0 ? '#fff' : '#FAFAF9' }}>
                      <td style={td}>
                        <span style={{ background: meta.bg, color: meta.color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                          {typeLabel[c.type] || c.type}
                        </span>
                      </td>
                      <td style={{ ...td, fontWeight: 500, color: '#1A1A1A' }}>{c.name}</td>
                      <td style={{ ...td, textAlign: 'center', color: '#888' }}>{c.duration_sec}s</td>
                      <td style={{ ...td, color: '#bbb', fontSize: 11, fontFamily: 'monospace', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {c.url ? c.url.replace('https://', '').substring(0, 50) : c.body ? c.body.substring(0, 50) : '—'}
                      </td>
                      <td style={{ ...td, textAlign: 'right' }}>
                        <button onClick={() => deleteContent(c.id).then(load)} style={btnDanger}>Delete</button>
                      </td>
                    </tr>
                  );
                })}
                {filtered.length === 0 && (
                  <tr><td colSpan={5} style={{ padding: 32, textAlign: 'center', color: '#aaa', fontSize: 14 }}>No content yet. Click "+ Add" to get started.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const hdr = { background: '#fff', borderBottom: '1px solid #E8E3DC', padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 10 };
const pageTitle = { fontSize: 18, fontWeight: 700, color: '#1A1A1A', margin: 0 };
const btnPrimary = { background: '#8B1E2D', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const btnDanger = { background: '#fff', color: '#9B2335', border: '1px solid #F5C6CB', borderRadius: 7, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap' };
const btnGhost = { background: 'none', color: '#888', border: '1px solid #E8E3DC', borderRadius: 8, padding: '7px 12px', fontSize: 12, cursor: 'pointer' };
const selectSt = { padding: '7px 10px', border: '1px solid #E8E3DC', borderRadius: 8, fontSize: 13, cursor: 'pointer', background: '#fff', color: '#333' };
const inp = { width: '100%', padding: '8px 12px', border: '1px solid #E8E3DC', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#FAFAF9' };
const formCard = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, padding: '16px', marginBottom: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const tableWrap = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const th = { padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#888', background: '#FAFAF9', letterSpacing: 0.3 };
const td = { padding: '11px 16px', color: '#555' };